import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-truncate-with-tooltip',
    templateUrl: './truncate-with-tooltip.component.html',
    styleUrls: ['./truncate-with-tooltip.component.scss'],
    standalone: false,
})
export class TruncateWithTooltipComponent {
    @Input() text = '';
    @Input() maxWidth = '200px';
    @Input() textColor = 'inherit';
}
